const content = {
  resume: {
    name: "Divyansh Yadav",
    links: [
      {
        label: "divyansh.yadav@gmail.com",
        url: "mailto:divyansh.yadav@gmail.com",
      },
      {
        label: "github.com/divyanshyadav",
        url: "https://github.com/divyanshyadav",
      },
      {
        label: "linkedin.com/in/divyanshyadav3",
        url: "https://www.linkedin.com/in/divyanshyadav3/",
      },
    ],
    workExperienceSection: {
      heading: "Work Experience",
      items: [
        {
          id: 1,
          company: "Amazon/IMDb",
          position: "Front End Engineer II",
          startDate: "11/2022",
          endDate: "Present",
          description: [
            "Led the design and implementation of the Server-Driven UI (SDUI) client and full-page architecture, creating reusable, scalable components that accelerated development across multiple IMDb Contribution workflows, reducing development time for contribution workflows by 60%.",
            "Created reusable components used to modernize all IMDb chart and list-like pages.",
            "Coordinated with various teams to standardize URL query parameters across the IMDb website and created a shared library for organization-wide use.",
            "Developed a scalable and reusable solution to render large lists (150+ expensive items), improving user interaction delay by 90%.",
            "Participated in team operations (CI/CD) to maintain owned systems once a month for a week.",
            "Worked in an agile environment to deliver products end-to-end.",
            "Maintained and enhanced www.boxofficemojo.com.",
          ],
        },
        {
          id: 2,
          company: "Wipro Digital",
          position: "Senior Software Engineer",
          startDate: "06/2019",
          endDate: "10/2022",
          description: [
            "Developed and shipped multiple front-end projects built from scratch for Lloyds Banking Group.",
            "Contributed to and maintained a front-end boilerplate, reducing setup time for new projects by approximately 70%.",
            "Developed and contributed reusable React components to a central repository, decreasing development time by 30%.",
            "Managed and mentored a team of 5+ front-end developers.",
            "Wrote comprehensive unit tests and routinely conducted performance stress testing.",
            "Optimized existing React applications, reducing load times by roughly 40%.",
            "Completed 500+ peer code reviews to promote best practices and scalable solutions.",
          ],
        },
        {
          id: 3,
          company: "Lean Apps GmbH",
          position: "Software Associate",
          startDate: "01/2016",
          endDate: "05/2019",
          description: [
            "Developed a chatbot web application for a pharmaceutical company that answered medicine-related queries, reducing customer support costs by 40–50%.",
            "Created and shipped a Point of Sale (POS) web application for retail stores and restaurants.",
            "Built a mobile app for retail stores allowing users to scan and check out items without waiting in long queues, reducing checkout times by 30–40%.",
            "Developed a command-line tool that retrieves JSON representations of LinkedIn/Xing user profiles, enabling backend applications to gather user information efficiently.",
            "Set up CI/CD pipelines for iOS apps in-house using Jenkins.",
          ],
        },
      ],
    },
    educationSection: {
      heading: "Education",
      items: [
        {
          id: 1,
          school: "UPES, College of Computer Science",
          degree: "Bachelor of Technology in Computer Science & Engineering",
          startDate: "04/2012",
          endDate: "05/2016",
          subjects: [
            "Data Structures",
            "Design & Analysis of Algorithms",
            "Object-Oriented Programming",
            "Data Communication & Networks",
            "DBMS",
            "Operating Systems",
            "Network Security & Cryptography",
          ],
        },
      ],
    },
    technicalSkillSection: {
      heading: "Technical Skills",
      items: [
        {
          label: "Proficient Languages & Libraries:",
          items: ["JavaScript", "React", "TypeScript", "Redux", "HTML", "CSS"],
        },
        {
          label: "Knowledgeable Languages & Libraries:",
          items: [
            "Node.js",
            "Redux-Saga",
            "React Testing Library",
            "Cypress",
            "GraphQL",
            "styled-components",
            "SCSS",
            "Java",
            "Python",
            "React Native",
            "Objective-C",
            "DialogFlow",
          ],
        },
        {
          label: "Tools:",
          items: ["Git", "Linux", "Jest", "ESLint", "Webpack", "Jenkins"],
        },
      ],
    },
  },
};

export default content;
